import { useState } from "react";
import { analyticsConsent, setAnalyticsConsent, trackPageView } from "@/lib/analytics";
import { Button } from "@/components/ui/button";

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(() => analyticsConsent());

  if (choice) return null;

  const decide = (granted) => {
    setAnalyticsConsent(granted);
    setChoice(granted ? "granted" : "denied");
    if (granted) trackPageView(window.location.pathname);
  };

  return (
    <aside
      className="relative z-20 border-b border-white/10 bg-[#15181a] px-5 py-3 md:flex md:items-center md:gap-5"
      aria-label="Analytics preferences"
      data-testid="analytics-consent-banner"
    >
      <p className="text-sm leading-relaxed text-white/70 md:flex-1">
        GamePlat uses optional Google Analytics to understand site traffic and waitlist conversions. No analytics loads unless you allow it. See our <a href="/privacy" className="text-gp-blue hover:underline">Privacy Policy</a>.
      </p>
      <div className="mt-3 flex gap-2 md:mt-0">
        <Button type="button" variant="outline" onClick={() => decide(false)} className="flex-1 rounded-full border-white/20 md:flex-none">
          Decline
        </Button>
        <Button type="button" onClick={() => decide(true)} className="flex-1 rounded-full bg-gp-blue font-bold md:flex-none">
          Allow analytics
        </Button>
      </div>
    </aside>
  );
}
